import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class PortalGuard implements CanActivate {
  staticRoutes = [
    '/portal/search-customer',
    '/portal/dashboard/admin',
    '/portal/dashboard/csr',
    '/portal/dashboard/negotiator',
    '/portal/pdf-scraper/dashboard',
    '/portal/pdf-scraper/test',
    '/portal/pdf-scraper/schema-builder',
    '/portal/pdf-scraper/scraping-templates',
    '/portal/pdf-scraper/edit-pdf-template',
    '/portal/comparator',
    '/portal/pdf-parser/templates',
    '/portal/pdf-parser/test',
    '/portal/pdf-parser/compare',
    '/portal/pdf-parser/results',
    '/portal/plans',
    '/portal/bots/live-chat',
    '/portal/dashboard'
  ];
  dynRoutes = [
    '/portal/account/', // /portal/account/:accountTaskId
    '/portal/customer/', // /portal/customer/:customerTaskId
    '/portal/comparator/', // /portal/comparator/:state
    '/portal/plans/create/', // /portal/plans/create/:state
    '/portal/plans/' // /portal/plans/:plan_type/:plan_id
  ];
  constructor(private _router: Router) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const currentUser = JSON.parse(localStorage.getItem('CURRENT_USER'));
    if (!currentUser) {
      this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    } else {
      if (currentUser.type === 0) {
        // admin is supreme and can roam anywhere
        return true;
      }
      if (state.url.includes('/negotiator') && currentUser.type === 4) {
        return true;
      } else if (state.url.includes('/csr') && currentUser.type === 2) {
        return true;
      } else if (this.staticRoutes.includes(state.url)) {
        return true;
      } else if (this.dynRoutes.map(r => state.url.includes(r)).length) {
        return true;
      } else {
        this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/_guards/portal.guard.ts